import React, { Component } from "react";
import "./Footer.scss";

function Footer(props) {
    return (
        <footer className="Footer-wrapper bg-primary text-white text-center">
            <div className="container fs-small">
                <div className="py-2 d-flex align-items-center justify-content-between flex-wrap">
                    <p className="mb-0 mr-2">Powered By Jigsaw</p>
                    <p className="mb-0 ">&#169; Zydelo Inc. All rights reserved</p>
                </div>
            </div>
        </footer>
    );
}   

export default Footer;
   